import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

import {
  IonContent, IonHeader, IonPage, IonButtons, IonMenuButton,
  IonTitle, IonBadge,
  IonToolbar, IonList, IonItem, IonLabel, IonSegment, IonSegmentButton, onIonViewDidEnter,
  onIonViewDidLeave,
} from '@ionic/vue';
import { ref, watch, WatchStopHandle } from 'vue';
import { useAuthStore } from '@/stores/auth.store';
import EmptyState from './components/EmptyState.vue'
import ListSkeletton from './components/ListSkeletton.vue'
import { rangeDateText } from '@/helpers/date';
import { getApi } from '@/helpers/api';
import { PeriodSkillsApi, DtoSkillCategory, DtoSkill } from 'ppf-api-client';
import { useRoute } from 'vue-router';



export default /*#__PURE__*/_defineComponent({
  __name: 'SkillsPage',
  setup(__props) {

let skills: DtoSkill[] = [];
const loading = ref(true);
const filter = ref<'current' | 'history'>('current');
const filteredList = ref<DtoSkill[]>([]);
const category = ref<DtoSkillCategory | null>(null);

const service = getApi(PeriodSkillsApi);
const auth = useAuthStore();
const now = new Date();
const route = useRoute();
const categoryId = ref(-1);

//watch route params changes so can update the content of the view when navigating between same view with route params
let unwatch: WatchStopHandle|undefined = undefined;

//load inital data when entering the tab
onIonViewDidEnter(() => {
  unwatch = watch(() => route.params, loadData);
  loadData()
});
//remove watcher on leave to avoid useless triggers from other routing
onIonViewDidLeave(() => {
  if (unwatch) unwatch()
})
function loadData() {
  const currentId = Number(route.params.categoryId);
  
  if (currentId > 0 && currentId != categoryId.value) {
    categoryId.value = currentId;
    loading.value = true;
    skills = [];
    
    service.periodSkillsCategory(categoryId.value).then(r => category.value = r);

    service.periodSkillsGetByCategory(categoryId.value, auth.userId, new Date()).then(r => {
      skills = r;
      loading.value = false;
      reloadList();
    });

  }
}
//filter change callback: reload list
const filterChanged = (e: any) => {
  filter.value = e.target.value;
  reloadList();
}

//reload list by reapplying filter and sort
const reloadList = () => {
  filteredList.value = skills
    .filter(c => filter.value == 'current' ? (!c.end || c.end >= now || c.end.getTime() == 0) : (c.end && c.end.getTime() > 0 && c.end < now))
    .sort((a, b) => {
      const at = a.start ? a.start.getTime() : 0;
      const bt = b.start ? b.start.getTime() : 0;
      return at - bt
    });
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButtons), { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonMenuButton))
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(category.value?.name), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonSegment), {
            value: filter.value,
            onIonChange: filterChanged
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonSegmentButton), { value: "current" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('g.current')), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(IonSegmentButton), { value: "history" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('g.history')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"]),
          _createVNode(_unref(IonList), null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredList.value, (c) => {
                return (_openBlock(), _createBlock(_unref(IonItem), {
                  key: c.id
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), null, {
                      default: _withCtx(() => [
                        _createElementVNode("h2", null, _toDisplayString(c.name), 1),
                        _createElementVNode("p", {
                          class: _normalizeClass({ disabled: c.disabled })
                        }, _toDisplayString(_unref(rangeDateText)(c.start, c.end)), 3)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_unref(IonBadge), {
                      slot: "end",
                      color: "medium"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(c.state), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(ListSkeletton, {
            style: _normalizeStyle({ display: loading.value ? 'block' : 'none' })
          }, null, 8, ["style"]),
          _createVNode(EmptyState, {
            style: _normalizeStyle({ display: loading.value || filteredList.value.length > 0 ? 'none' : 'block' }),
            icon: "fa-certificate"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('p.skill.empty')), 1)
            ]),
            _: 1
          }, 8, ["style"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})